import React from "react";
import { Link } from "react-router-dom";
import Header from "../../layout/mypage/LoginHeader";
import Footer from "../../layout/mypage/Footer";

const PageNotFound = () => {
  return (
    <div className="mypage-site">
      <Header />
      <div className="l-main">
        <div className="container">
          <div className="col-lg-10 offset-lg-1">
            <div className="l-page-con">
              <h1 className="p-heading01">
                ご指定のページまたはファイルは見つかりませんでした
              </h1>
              {process.env.REACT_APP_DEBUG_MODE === "true" ? (
                <div className="border border-secondary border-2 mt-5">
                  <h2 className="p-heading02">開発用リンク</h2>
                  <ul>
                    <li>
                      <a href="/admin">admin</a>
                    </li>
                    <li>
                      <a href="/mypage">mypage</a>
                    </li>
                  </ul>
                </div>
              ) : (
                <></>
              )}
              <p className="p-404-img">
                <img src="/common/assets/images/404image_02.png" alt="" />
              </p>
              <label>
                「渋谷生涯活躍ネットワーク・シブカツ(通称：シブカツ)」サイトにアクセスしていただきありがとうございます。
                <br />
                大変申し訳ございませんが、該当するページが以下のような理由で存在しません。
              </label>
              <div className="li_box mt-5 mb-5">
                <li>すでに削除されて無効になっている。</li>
                <li>URLの入力やリンク先が間違っている、変更されている。</li>
                <li>一時的にアクセスが出来なくなっている。</li>
              </div>
              <div className="p-course-page__btn">
                <a
                  className="p-course-page__btn-link"
                  href={process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/"}
                >
                  シブカツトップページに戻る
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer is_login={true} />
    </div>
  );
};
export default PageNotFound;
